import APIConfig from './api';
import ERROR_MESSAGE from './errorMessage';
import SUCCESS_MESSAGE from './successMessages';
import LABEL from './label';
import CUSTOM_MESSAGES from './customMessage';
import APP_CONFIG from './appConfig';

export {
  APIConfig,
  APP_CONFIG,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  LABEL,
  CUSTOM_MESSAGES
};
